import type { InjectionKey } from 'vue'
import { inject, provide } from '#imports'

const DEFERRED_MEDIA: InjectionKey<boolean> = Symbol('deferred-media')

/** 1x1 transparent GIF, the image placeholder while media is deferred. */
export const DEFERRED_MEDIA_PLACEHOLDER = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='

/**
 * Marks a subtree as below the fold. Images in it render a placeholder in the SSR HTML and
 * load their real source when they mount, so a lazily hydrated section fetches its images
 * only once it hydrates.
 */
export function provideDeferredMedia(defer = true) {
    provide(DEFERRED_MEDIA, defer)
}

/** The `placeholder` for a `NuxtImg` in this subtree: set while deferred, otherwise none. */
export function useDeferredMedia() {
    const deferred = inject(DEFERRED_MEDIA, false)

    return {
        imagePlaceholder: deferred ? DEFERRED_MEDIA_PLACEHOLDER : undefined,
    }
}
